<p-messages *ngIf="tipo==='porEnviar' && listExams.length>0" severity="info">
  <ng-template pTemplate>
    <div class="p-ml-2">
      <i class="pi pi-info-circle" style="margin-right: 10px"></i>
      <strong>Los exámenes en esta bandeja serán enviados automáticamente apenas se detecte
        conexión a internet.
      </strong>
    </div>
  </ng-template>
</p-messages>

<p-dataView #dv [value]="listExams" [paginator]="true" [filterBy]="filterBy" [rows]="confPage.rows"
  [first]="confPage.first" [pageLinks]="0" [paginatorPosition]="'top'" [rowsPerPageOptions]="[5,10,20,30]"
  [showCurrentPageReport]="true" [showFirstLastIcon]="false" (onPage)="onPage($event, tipo)"
  currentPageReportTemplate="{first} - {last} de {totalRecords} exámenes" emptyMessage=" ">
  <div>tipo: {{tipo}}</div>

  <ng-template pTemplate="paginatorleft">
    <div [ngClass]="{'disable_filter': !isOnline }" style="display: flex">
      <div class="field-paginator-left">
        <div class="p-input-icon-right">
          <i class="pi pi-search"></i>
          <input id="search" (input)="actionFilter($event)" [(ngModel)]="inputSearch" name="seacrh" pInputText
            placeholder="Buscar" type="search">
        </div>
      </div>

      <div class="content_filter" style="display: flex; justify-content: flex-end; margin-top: 10px">
        <div *ngIf="tipo==='cargados'" (click)="filtros()" style="display: flex;">

          <div class="filter-icon">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4 8C1.8 8 0 6.2 0 4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 14c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
              <path
                d="M23 5H7c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1zm0 8h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm-10 0H1c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1zm-3 11c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
              <path
                d="M23 21H13c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1zM7 21H1c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" />
            </svg>
          </div>

          <label *ngIf="tipo==='cargados'" class="filter-label">
            Filtros {{filterCountCargado ? '(' + filterCountCargado + ')' : ''}}
          </label>
        </div>

        <label (click)="limpiarFiltro()" *ngIf=" tipo==='cargados' && filterCountCargado" class="filter-label filter-clean">
          Limpiar Filtros
        </label>
      </div>

    </div>
  </ng-template>

  <ng-template let-examen let-i="index" pTemplate="listItem">
    <div style="flex-direction: column; width: 100%; margin-bottom: 10px;">
      <app-examens-cargados-card-item [card]="examen" [isLastCardItem]="true"></app-examens-cargados-card-item>
    </div>
  </ng-template>

</p-dataView>

<div *ngIf="tipo==='cargados'">
  <app-empty-state *ngIf="filterCountCargado <= 0 && listExams.length <=0"
    [filterEmpty]="true" [tittle]="'No hay información para mostrar'"
    [subTittle]="'Debe utilizar los filtros para realizar una búsqueda'">
  </app-empty-state>
  <app-empty-state *ngIf="filterCountCargado>0 && listExams.length <=0"
    [filterEmpty]="true" [subTittle]="'No se encontraron resultados para la búsqueda'" [tittle]="'No hay exámenes'">
  </app-empty-state>
</div>
